import {BaseEntity} from "./BaseEntity";

export class Plugin implements BaseEntity {
    constructor(
        public id?:number,
        public name?:string,
        public description?:string,
        public fileDataID?:number,
        public lastModifiedBy?:string) {
    }
    parseJson(json: any): void {
        this.id= json.id;
        this.name = json.name;
        this.description = json.description;
        this.fileDataID = json.fileDataID;
        this.lastModifiedBy = json.lastModifiedBy;
    }
}
